class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// window.addonProduct = async function (variantID, targetButton) {
//   if (!variantID) return console.log('No Product Found');
//   let cartDrawer =  document.querySelector('cart-drawer.drawer');  
  
//   // cartDrawer?.classList.add('is-loading');
//   targetButton.classList.add('is-loading');
  
  
//   try {
//     const formData = new FormData();
//     formData.append('id', variantID);
//     formData.append('quantity', '1');

//     const response = await fetch(routes.cart_add_url || '/cart/add.js', {
//       method: 'POST',
//       body: formData,
//       headers: { 'X-Requested-With': 'XMLHttpRequest' },
//     });

//     if (!response.ok) throw new Error('Failed to add item');

//     // Refresh drawer items
//     document.querySelector('cart-drawer-items')?.onCartUpdate();

//     // Open drawer
//     // document.querySelector('cart-drawer')?.open();

//   } catch (error) {
//     console.error(error);
//   } finally {
//     console.log('Addon Product successfully added and drawer refreshed.');
    
//     // cartDrawer?.classList.remove('is-loading');
//     targetButton.classList.remove('is-loading');
//   }
// };
window.addonProduct = async function (button) {
  const container = button.closest('[data-addon-product-id]');
  if (!container) return console.log('Addon container not found');

  let variantId;
  const select = container.querySelector('.addon-variant-select');

  if (select) {
    variantId = select.value;
    if (!variantId) {
      alert('Please select a variant');
      return;
    }
  } else {
    variantId = button.dataset.variantId;
    if (!variantId) return console.log('No variant ID found');
  }

  button.classList.add('is-loading');

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!response.ok) {
      let err;
      try { err = await response.json(); } catch { err = {}; }
      throw new Error(err.description || err.message || 'Could not add product');
    }

    // ── Update drawer ───────────────────────────────
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();  // most important for UX

      // Refresh contents (Dawn-friendly way)
      const items = document.querySelector('cart-drawer-items');
      if (items?.onCartUpdate) items.onCartUpdate();
    }

    console.log('Addon added');

  } catch (err) {
    console.error(err);
    alert(err.message || 'Something went wrong – please try again');
  } finally {
    button.classList.remove('is-loading');
  }
};